import React from "react";
import studioData from "../data/studioData.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  const { phone, email } = studioData.studioProfile;
  const contactContent = studioData.siteContent?.contact ?? {};
  const whatsappNumber = phone?.replace(/\D/g, "");
  const whatsappLink = `https://wa.me/${whatsappNumber}`;

  return (
    <section id="contact" className="relative z-10 mx-auto w-full max-w-6xl px-6 py-12 md:py-16">
      <div className="glass-panel p-8 md:p-12">
        <p className="section-kicker">{contactContent.kicker ?? "06 Contact"}</p>
        <h2 className="section-title">{contactContent.title ?? "Let’s discuss your next space"}</h2>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-text-secondary md:text-base">
          {contactContent.description ??
            "We work closely with clients, consultants, and contractors to deliver architecture and interiors with precision, from first sketch to final handover."}
        </p>

        <div className="mt-7 flex flex-wrap gap-4">
          {phone && (
            <a
              href={whatsappLink}
              className="glass-button inline-flex items-center gap-2 px-6"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat on WhatsApp"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>{contactContent.whatsappLabel ?? "WhatsApp"}</span>
            </a>
          )}
          {email && (
            <a
              href={`mailto:${email}`}
              className="outline-link inline-flex items-center gap-2 px-6"
              aria-label="Email Studio"
            >
              <FontAwesomeIcon icon={faEnvelope} />
              <span>{contactContent.emailLabel ?? "Email"}</span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
